import { z } from 'zod';
// ---------- A1 Contactos de cliente ----------
export const ClientContactDtoSchema = z.object({
    id: z.string(),
    clientId: z.string(),
    name: z.string(),
    role: z.string().nullable(),
    email: z.string().nullable(),
    phone: z.string().nullable(),
    notes: z.string().nullable(),
    isPrimary: z.boolean(),
    createdAt: z.string(),
});
export const CreateClientContactSchema = z.object({
    name: z.string().trim().min(2).max(200),
    role: z.string().trim().max(120).nullable().optional(),
    email: z.string().trim().email().max(200).nullable().optional(),
    phone: z.string().trim().max(40).nullable().optional(),
    notes: z.string().max(2000).nullable().optional(),
    isPrimary: z.boolean().default(false),
});
export const UpdateClientContactSchema = z
    .object({
    name: z.string().trim().min(2).max(200).optional(),
    role: z.string().trim().max(120).nullable().optional(),
    email: z.string().trim().email().max(200).nullable().optional(),
    phone: z.string().trim().max(40).nullable().optional(),
    notes: z.string().max(2000).nullable().optional(),
    isPrimary: z.boolean().optional(),
})
    .refine((d) => Object.keys(d).length > 0, { message: 'Sin cambios' });
export const ClientContactListResponseSchema = z.object({
    items: z.array(ClientContactDtoSchema),
});
// ---------- A1 Resumen de la ficha ----------
/** Contadores de cada módulo de la ficha del cliente (una sola llamada). */
export const ClientSummarySchema = z.object({
    cases: z.object({ active: z.number().int(), total: z.number().int() }),
    documents: z.object({ total: z.number().int() }),
    quotes: z.object({
        open: z.number().int(),
        accepted: z.number().int(),
        total: z.number().int(),
    }),
    billing: z.object({
        /** Base imponible de lo facturado (sin borradores ni proformas). */
        billedCents: z.number().int(),
        paidCents: z.number().int(),
        /** Lo que falta por cobrar de las facturas emitidas. */
        pendingCents: z.number().int(),
        invoicesCount: z.number().int(),
        draftsCount: z.number().int(),
    }),
    funds: z.object({ availableCents: z.number().int() }),
    recurring: z.object({ active: z.number().int() }),
    milestones: z.object({ pendingCount: z.number().int(), pendingCents: z.number().int() }),
    communications: z.object({ total: z.number().int() }),
    /** A4: horas facturables todavía sin facturar (expedientes del cliente). */
    unbilledTime: z.object({ minutes: z.number().int(), amountCents: z.number().int() }),
});
//# sourceMappingURL=client-contacts.js.map